import Mailchimp from "../components/Mailchimp";

const Home = (props) => {

    const { submitted, setSubmitted } = props;
  return (
    <>
             <Mailchimp
        {...{
          submitted,
          setSubmitted,
        }}
      />
    
            <a  href="/">
          <img className="dreamland__peach" src="assets/peach.png" alt="PEACH" />
        </a>
    </>
 
  )
}

export default Home